import React from 'react';
import Link from '@material-ui/core/Link';
import { Link as RouterLink } from 'react-router-dom';
import useLocale from './hooks';
import { translateUrl } from './utils';

const MyLink = ({ to, children, translate = true, ...rest }) => {
  const { locale } = useLocale();

  const url = translate ? translateUrl(to, locale) : to;
  return (
    <Link {...rest} to={url} component={RouterLink}>
      {children}
    </Link>
  );
};

export default MyLink;
